import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SidebarService {
  // Signal to store collapsed/expanded state
  private _isCollapsed = signal(false);

  isCollapsed = this._isCollapsed.asReadonly(); // expose read-only

  toggleSidebar() {
    this._isCollapsed.update((value) => !value);
  }

  closeSidebar() {
    this._isCollapsed.set(true);
  }

  openSidebar() {
    this._isCollapsed.set(false);
  }
}
